import { readConstants } from "../../../actions/ncs/read";
import { writeConstants } from "../../../actions/ncs/write";
import { preferencesConstants } from "../../../actions/ncs/preferences";

const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    }
  },
  data: [],
  exist: false,
  preferences: []
};

export const getNotificationsUnread = (notifications) => {
  return !!notifications.find((n) => !n.read);
};

export function notifications(state = defaultState, { type, payload, error }) {
  let notifications;

  switch (type) {
  case readConstants.GET_NOTIFICATION_LIST_START:
    return {
      ...state,
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case readConstants.GET_NOTIFICATION_LIST_SUCCESS:
    notifications = payload.notifications.filter((el) => el.appCode === "digital-box");
    return {
      ...state,
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload.notifications,
      exist: getNotificationsUnread(notifications)
    };
  case readConstants.GET_NOTIFICATION_LIST_ERROR:
    return {
      ...state,
      status: {
        started: false,
        error: true,
        ended: false,
        errorInfo: { code: error.code, message: error.message }
      }
    };
  case writeConstants.DELETE_NOTIFICATIONS_LIST_START:
    return {
      ...state,
      data: [],
      exist: false
    };
  case writeConstants.DELETE_NOTIFICATIONS_LIST_ERROR:
    notifications = payload.prevNotifications.filter((el) => el.appCode === "digital-box");
    return {
      ...state,
      status: {
        started: false,
        error: true,
        ended: false,
        errorInfo: { code: error.code, message: error.message }
      },
      data: payload.prevNotifications,
      exist: getNotificationsUnread(notifications)
    };
  case writeConstants.DELETE_SINGLE_NOTIFICATION_START:
    notifications = state.data.filter((n) => n.id !== payload.notificationId);
    return {
      ...state,
      data: notifications,
      exist: getNotificationsUnread(notifications)
    };
  case writeConstants.DELETE_SINGLE_NOTIFICATION_ERROR:
    notifications = payload.prevNotifications.filter((el) => el.appCode === "digital-box");
    return {
      ...state,
      status: {
        started: false,
        error: true,
        ended: false,
        errorInfo: { code: error.code, message: error.message }
      },
      data: payload.prevNotifications,
      exist: getNotificationsUnread(notifications)
    };
  case writeConstants.UPDATE_NCS_NOTIFICATIONS_LIST_START:
    notifications = state.data.map((notification) => ({ ...notification, ...payload.request }));
    return {
      ...state,
      data: notifications,
      exist: getNotificationsUnread(notifications)
    };
  case writeConstants.UPDATE_NCS_NOTIFICATIONS_LIST_ERROR:
    return {
      ...state,
      status: {
        started: false,
        error: true,
        ended: false,
        errorInfo: { code: error.code, message: error.message }
      },
      data: payload.prevNotifications,
      exist: getNotificationsUnread(payload.prevNotifications)
    };
  case writeConstants.UPDATE_NCS_SINGLE_NOTIFICATION_START:
    notifications = state.data.map((notification) => {
      return notification.id === payload.notificationId
        ? {
          ...notification,
          ...payload.request
        }
        : notification;
    });
    return {
      ...state,
      data: notifications,
      exist: getNotificationsUnread(notifications)
    };
  case writeConstants.UPDATE_NCS_SINGLE_NOTIFICATION_ERROR:
    return {
      ...state,
      status: {
        started: false,
        error: true,
        ended: false,
        errorInfo: { code: error.code, message: error.message }
      },
      data: payload.prevNotifications,
      exist: getNotificationsUnread(payload.prevNotifications)
    };
  case preferencesConstants.GET_NOTIFY_PREFERENCES_SUCCESS:
    return {
      ...state,
      preferences: payload,
      isGettingPreferences: false
    };
  case preferencesConstants.GET_NOTIFY_PREFERENCES_START:
    return {
      ...state,
      preferences: [],
      isGettingPreferences: true
    };
  case preferencesConstants.GET_NOTIFY_PREFERENCES_ERROR:
    return {
      ...state,
      preferences: [],
      isGettingPreferences: false
    };
  default:
    return state;
  }
}

export function isGettingPreferences(state, { type }) {
  let defaultState = typeof state === "undefined" ? true : state;
  switch (type) {
  case preferencesConstants.GET_NOTIFY_PREFERENCES_START:
    return true;
  case preferencesConstants.GET_NOTIFY_PREFERENCES_SUCCESS:
  case preferencesConstants.GET_NOTIFY_PREFERENCES_ERROR:
    return false;
  default:
    return defaultState;
  }
}
